import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { BarChartComponent } from './bar-chart.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [BarChartComponent],
    declarations: [BarChartComponent],
    providers: [],
})
export class BarChartModule { }
